import { IonIcon } from '@ionic/react';
import { logOutOutline, helpOutline } from 'ionicons/icons';
import { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { DEFAULT_AVATAR_URL, WP_HouseMainPage } from '../../model/models';

import HouseCard from '../house/houseCard';
import { Auth } from '../../services/AuthService';
import { Link, useLocation } from 'react-router-dom';
import { AppContext } from '../../state/AppContextProvider';
import IconsMenu from './IconMenu';
import DirectoryWidget from '../directory/DirectoryWidget';
import { useLogger } from '../../services/LogService';
import { ModelsService } from '../../services/ModelsService';

interface SideBarProps {}
const SideBar: React.FC<SideBarProps> = () => {
  const { state } = useContext(AppContext);

  const logger = useLogger('SideBar');

  const [loading, setLoading] = useState(false);

  const location = useLocation();

  const map_page = location.pathname.includes('/pages/map') ? ' xl:hidden' : '';

  const handleSignOut = (e: any) => {
    e.preventDefault();
    setLoading(true);
    Auth.signOut(true).finally(() => {
      // setLoading(false);
    });
    return false;
  };

  useEffect(() => {
    logger.info('useEffect()', state.isConnected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isConnected]);

  if (state.isConnected) {
    const houseMainPage: WP_HouseMainPage =
      state.housePages &&
      (state.housePages.find((h) => h.parent === 0) as WP_HouseMainPage);

    const iconsMenu = [
      {
        icon: '/assets/nav/notif.svg',
        to: '/notifications',
        hasNotif: state.nbUnreadNotifs > 0,
      },
      { icon: '/assets/nav/search.svg', to: '/search' },
    ];

    const activeUserHouse = ModelsService.getUserActiveHouse(state.user);

    return (
      <div
        className={
          'hidden absolute right-0 top-0 w-96 h-screen flex-col justify-start px-5 py-4 overflow-hidden xl:flex sidebar-wrapper' +
          map_page
        }
      >
        <div className="flex flex-row justify-between items-center mb-5">
          <div>
            <IconsMenu menu={iconsMenu} />
          </div>
          <div>
            <a
              href="#logout"
              onClick={handleSignOut}
              className={`font-bold text-sm flex justify-end items-center ${
                loading === true ? 'text-lightGrey' : 'text-primary'
              }`}
            >
              <FormattedMessage id="Logout" />
              <IonIcon icon={logOutOutline} className="text-xl ml-2" />
            </a>
          </div>
        </div>
        <div className="flex flex-row items-center h-auto w-full p-6 mb-5">
          <div className="rounded-full flex justify-center items-center mr-5 h-20 w-20">
            <img
              className="inline-block h-20 w-20 rounded-full object-cover"
              src={state.user?.acf.photo || DEFAULT_AVATAR_URL}
              alt=""
            />
          </div>
          <div>
            <h4 className="flex flex-col text-lg font-bold text-black leading-5">
              <span className="uppercase">
                {state.user?.last_name || 'Not loaded yet'}
              </span>
              <span>{state.user?.first_name || 'Not loaded yet'}</span>
            </h4>
            <Link
              to="/profile/edit"
              className="text-primary font-bold text-sm mt-3 block"
            >
              <FormattedMessage id="See my profile" />
            </Link>
          </div>
        </div>
        {houseMainPage && <HouseCard houseMainPage={houseMainPage} />}
        {activeUserHouse && (
          <DirectoryWidget
            title="My house committee"
            tagSlugs={['committee']}
            house={activeUserHouse.term_id}
            nbUserToDisplay={3}
          />
        )}
        <a href="mailto:support@ciup.help">
          <div className="flex self-end items-center px-6 py-4 mt-3 w-full border border-transparent shadow-sm text-sm font-bold rounded-3xl text-white bg-primary hover:bg-primary hover:bg-opacity-75 focus:outline-none ">
            <div className="flex items-center justify-center w-8 h-8 p-2 mr-4 inset-0 leading-none rounded-full text-primary bg-white">
              <IonIcon icon={helpOutline} />
            </div>
            <div>
              <h4 className="text-white text-sm font-bold">
                <FormattedMessage id="Need help ?" />
              </h4>
              <p className="text-xs italic text-white font-normal">
                <FormattedMessage id="The Residents Portal team will help you by email : " />
                support@ciup.help
              </p>
            </div>
          </div>
        </a>
      </div>
    );
  } else {
    return <div className="hidden"></div>;
  }
};

export default SideBar;
